import { createReducer, on } from '@ngrx/store';

import * as actions from './general.actions';
import { CompanyInfo, General, PersonalInfo } from './models/general';

export const GENERAL_FEATURE_KEY = 'general';

export interface GeneralState {
  general: General;
  personalInfo: PersonalInfo;
  companyInfo: CompanyInfo;
  isLoading: boolean;
}

export const initialState: GeneralState = {
  general: null,
  personalInfo: null,
  companyInfo: null,
  isLoading: false,
};

export const generalReducer = createReducer(
  initialState,
  on(actions.getGeneral, (state) => ({
    ...state,
    isLoading: true,
  })),
  on(actions.getGeneralSuccess, (state, { general }) => ({
    ...state,
    general,
    isLoading: false,
  })),
  on(actions.getGeneralFailure, (state) => ({
    ...state,
    isLoading: false,
  })),
  on(actions.updateGeneralPersonalInfo, (state) => ({
    ...state,
  })),
  on(actions.updateGeneralPersonalInfoSuccess, (state, { personalInfo }) => {
    return {
      ...state,
      personalInfo,
    };
  }),
  on(actions.updateGeneralCompanyInfo, (state) => ({
    ...state,
  })),
  on(actions.updateGeneralCompanyInfoSuccess, (state, { companyInfo }) => {
    return {
      ...state,
      companyInfo,
    };
  }),
);
